:host,
.ld-sr-only {
  position: absolute;
  width: var(--ld-sp-1);
  height: var(--ld-sp-1);
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border-width: 0;
}
